import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacings.spacing32};
  display: flex;
  flex-direction: column;
`;

export default Wrapper;
